import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';
import { API } from '@/App';
import { toast } from 'sonner';

export default function ErrorLogsPanel({ errorLogs, onRefresh }) {
  const handleMarkErrorInvestigated = async (logId) => {
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`${API}/admin/error-logs/${logId}/investigate`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        toast.success('Marked as investigated');
        onRefresh();
      }
    } catch (error) {
      toast.error('Failed to update error log');
    }
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-6">Error Logs (Last 200)</h2>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full">
          <thead className="bg-slate-50 border-b">
            <tr>
              <th className="text-left px-6 py-3 text-sm font-semibold text-slate-700">Time</th>
              <th className="text-left px-6 py-3 text-sm font-semibold text-slate-700">Type</th>
              <th className="text-left px-6 py-3 text-sm font-semibold text-slate-700">Message</th>
              <th className="text-left px-6 py-3 text-sm font-semibold text-slate-700">User</th>
              <th className="text-left px-6 py-3 text-sm font-semibold text-slate-700">URL</th>
              <th className="text-center px-6 py-3 text-sm font-semibold text-slate-700">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y text-sm">
            {errorLogs.map(log => (
              <tr key={log.log_id} className={log.investigated ? 'bg-slate-50' : ''}>
                <td className="px-6 py-3 text-xs text-slate-600">
                  {new Date(log.created_at).toLocaleString()}
                </td>
                <td className="px-6 py-3">
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                    log.error_type === 'frontend' ? 'bg-blue-100 text-blue-700' :
                    log.error_type === 'backend' ? 'bg-red-100 text-red-700' :
                    'bg-orange-100 text-orange-700'
                  }`}>
                    {log.error_type}
                  </span>
                </td>
                <td className="px-6 py-3 text-slate-700 max-w-md truncate">
                  {log.message}
                </td>
                <td className="px-6 py-3 text-slate-600">
                  {log.user_email || 'Anonymous'}
                </td>
                <td className="px-6 py-3 text-slate-600 text-xs max-w-xs truncate">
                  {log.url || '—'}
                </td>
                <td className="px-6 py-3 text-center">
                  {!log.investigated && (
                    <Button
                      size="sm"
                      variant="ghost"
                      onClick={() => handleMarkErrorInvestigated(log.log_id)}
                      className="text-xs"
                    >
                      <CheckCircle className="w-4 h-4" />
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
